import React from 'react';
import {
    Link
} from "react-router-dom";

const settings = () => {
    return(
        <div className="choose-deals-outer p-l-0 p-r-0">
            <div className="container">
                <div className="row">
                    <div className="col-md-12 col-lg-5 mx-auto px--xs-0">
                        <div className="settings-box">
                            <div className="settings-boxrows">
                                <h6 className="settings-headingtitle green-color">Privacy</h6>
                                <Link to={`${process.env.PUBLIC_URL}/change-password`} className="anchor--password">Change password</Link>
                            </div>

                            {/*<div className="settings-boxrows d-xl-none">
                                <h6 className="settings-headingtitle green-color">Notifications</h6>
                                <div>
                                    <div className="custom-control custom-switch notify--custom">
                                        <span>Push Notifications</span>
                                        <input type="checkbox" className="custom-control-input" id="custompush"/>
                                            <label className="custom-control-label" htmlFor="custompush"></label>
                                    </div>
                                </div>
                            </div>*/}
                            <div className="settings-boxrows">
                                <h6 className="settings-headingtitle green-color">About</h6>
                                <ul className="list-unstyled mb-0">
                                    <li><a href="/terms-of-use" target="_blank" rel="noopener noreferrer" className="anchor--password">Legal</a></li>
                                </ul>
                            </div>
                        <div className="settings-boxrows">
                            <h6 className="settings-headingtitle mb-2 green-color">Host4VIP {/*<span className="d-lg-none">App</span>*/}</h6>
                            <p className="mb-0 text-white">Version 1.0.0</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    )
}

export default settings;